<template>
  <v-app>
    <v-container fluid>
      <v-row v-if="$insertAccess($route.path)">
        <!-- LEFT SIDE -->
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Others Info
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">

                <v-autocomplete
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    v-model="requisition_master_id.value.value"
                    :items="getRawMetarialRequisitionList"
                    item-title="code"
                    item-value="id"
                    :error-messages="requisition_master_id.errorMessage.value"
                    clearable
                    @update:modelValue="loadRequisitionDetails"
                    >
                    <template #label>
                        Requisition <span class="text-red">*</span>
                    </template>
                </v-autocomplete>

                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    v-model="warehouse_id.value.value"
                    :items="getWarehouseList"
                    item-title="name"
                    item-value="id"
                    :error-messages="warehouse_id.errorMessage.value"
                    clearable
                  >
                    <template #label>
                      Warehouse <span class="text-red">*</span>
                    </template>
                  </v-autocomplete>

                  <v-autocomplete
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    v-model="department_id.value.value"
                    :items="getHrmDepartmentList"
                    item-title="name"
                    item-value="id"
                    :error-messages="department_id.errorMessage.value"
                    clearable
                  >
                    <template #label>
                      Department <span class="text-red">*</span>
                    </template>
                  </v-autocomplete>

                  <v-date-input
                    input-format="dd/mm/yyyy"
                    density="compact"
                    prepend-inner-icon="mdi-calendar"
                    prepend-icon=""
                    variant="outlined"
                    bg-color="grey-lighten-4"
                    v-model="requisition_delivery_date.value.value"
                    :error-messages="requisition_delivery_date.errorMessage.value"
                  >
                    <template #label>
                      Requisition Delivery Date
                      <span class="text-red">*</span>
                    </template>
                  </v-date-input>

                  <v-text-field
                    label="Receive By"
                    density="compact"
                    variant="outlined"
                    bg-color="grey-lighten-4"
                    v-model="receive_by.value.value"
                    disabled
                  ></v-text-field>

                  <v-text-field
                    label="Mobile"
                    density="compact"
                    variant="outlined"
                    bg-color="grey-lighten-4"
                    v-model="receive_by_mobile.value.value"
                    disabled
                  ></v-text-field>

                  <v-text-field
                    label="Email"
                    density="compact"
                    variant="outlined"
                    bg-color="grey-lighten-4"
                    v-model="receive_by_email.value.value"
                    disabled
                  ></v-text-field>

                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- RIGHT SIDE -->
        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Item Info
              </v-expansion-panel-title>

              <v-expansion-panel-text>

                <!-- CART TABLE -->
                <v-table density="compact" fixed-header height="400">

                  <thead>
                    <tr>
                      <th>SL</th>
                      <th>Code</th>
                      <th>Product</th>
                      <th>Qty</th>
                      <th>Unit</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(item,index) in cart" :key="index">

                      <td>{{ index+1 }}</td>

                      <td>{{ item.code }}</td>

                      <td>{{ item.product_name }}</td>

                      <td>
                        <v-text-field
                          type="number"
                          density="compact"
                          variant="outlined"
                          v-model="item.qty"
                          style="width:90px"
                        ></v-text-field>
                      </td>

                      <td>{{ item.unit_name }}</td>

                      <td>
                        <v-icon
                          color="red"
                          size="small"
                          @click="removeFromCart(index)"
                        >
                          mdi-delete
                        </v-icon>
                      </td>

                    </tr>

                    <tr v-if="cart.length==0">
                      <td colspan="6" class="text-center">
                        No Item Added
                      </td>
                    </tr>

                  </tbody>

                </v-table>

                <v-divider class="mt-4"></v-divider>

                <v-row class="mt-2">

                  <v-col cols="8">

                    <v-textarea
                      label="Remarks"
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      v-model="remarks.value.value"
                      rows="3"
                    ></v-textarea>

                  </v-col>

                  <v-col cols="4">

                    <v-layout class="justify-end">

                      <v-btn
                        class="bg-grey-darken-1 me-2"
                        @click="submitForm(0)"
                      >
                        Draft
                      </v-btn>

                      <v-btn
                        class="bg-primary"
                        @click="submitForm(1)"
                      >
                        Post
                      </v-btn>

                    </v-layout>

                  </v-col>

                </v-row>

              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>

import { ref,computed,onMounted,nextTick } from "vue"
import { useStore } from "vuex"
import { useRouter,useRoute } from "vue-router"
import { useForm,useField } from "vee-validate"
import * as yup from "yup"
import { toast } from "vue3-toastify"
import formattedDate from "@/plugins/dateFormatter"

const store = useStore()
const router = useRouter()
const route = useRoute()

const panel = ref([0])
const panel2 = ref([0])
const cart = ref([])
const requisition_delivery_master_id = route.query.id ?? null

const { handleSubmit,resetForm } = useForm({

 validationSchema:yup.object({

  requisition_delivery_date:yup.date().required(),

  requisition_master_id:yup.number().required(),
  warehouse_id:yup.number().required(),
  
  department_id:yup.number().required()

 })

})

const requisition_master_id = useField("requisition_master_id")
const warehouse_id = useField("warehouse_id")
const department_id = useField("department_id")
const requisition_delivery_date = useField("requisition_delivery_date")
const remarks = useField("remarks")

const receive_by = useField("receive_by")
const receive_by_mobile = useField("receive_by_mobile")
const receive_by_email = useField("receive_by_email")

const currentStatus = ref(0)

const getWarehouseList = computed(()=>store.getters.getWarehouseList)

const getHrmDepartmentList = computed(()=>store.getters.getHrmDepartmentList)
const getRawMetarialRequisitionList = computed(()=>store.getters.getRawMetarialRequisitionList)

const getProductMapList = computed(()=>{

 return store.getters.getProductMapList.filter(
  p=>p.branch_id==store.getters.getAuthUser.branch_id && p.status==1
 )

})

const loadRequisitionDetails = (id) => {

  if(!id){ cart.value = []; return;}

  store.dispatch("getRawMetarialRequisitionById", id).then(res => {
    const details = res.data.details
    console.log(details);
    cart.value = []
    details.forEach(d => {
      d.raw_product_details.forEach(i => {
        cart.value.push({
          code: i.raw_product?.code,
          product_name: i.raw_product?.name,
          unit_name: i.raw_product?.unit?.name ?? '',
          product_id: i.raw_product?.id,
          qty: i.total_required_quantity,
          template_id: i?.template_id,
        })

      })
    })
  })
}


const removeFromCart=(index)=>{

 if(confirm("Are you sure?")){
  cart.value.splice(index,1)
 }

}

const submitForm=(s)=>{

 currentStatus.value=s
 submit()

}

const submit = handleSubmit((values)=>{

  values.requisition_delivery_master_id = requisition_delivery_master_id;
  values.status=currentStatus.value;
  values.cart=cart.value;
  values.requisition_delivery_date = formattedDate(requisition_delivery_date.value.value);

 store.dispatch("saveUpdateInvProductionRequisitionDelivery",values)

 .then(res=>{

  resetForm()
  cart.value=[]

  toast.success(res.data.message)

  setTimeout(()=>{
   router.push({name:"production-requisition-delivery-records"})
  },2000)

 })

 .catch(e=>toast.error(e.response.data.message))

})

const loadEditData = (id) => {

  store.dispatch("getInvProductionRequisitionDeliveryById", id)
  .then(data => {

    store.commit("SET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST",[data.requisition_master]);

    requisition_master_id.value.value = data.requisition_master_id
    warehouse_id.value.value = data.warehouse_id
    department_id.value.value = data.department_id

    requisition_delivery_date.value.value = new Date(data.requisition_delivery_date)

    remarks.value.value = data.remarks

    receive_by.value.value = data.receive_by
    receive_by_mobile.value.value = data.receive_by_mobile
    receive_by_email.value.value = data.receive_by_email

    cart.value = data.requisition_delivery_details.map(d => ({
      code: d.product?.code,
      product_name: d.product?.name,
      unit_name: d.product?.unit?.name ?? '',
      product_id: d.product_id,
      template_id: d.template_id,
      qty: d.qty
    }))

  })
}

onMounted(()=>{

 if(store.getters.getWarehouseList.length==0){
  store.dispatch("getWarehouseList")
 }

 if(store.getters.getHrmDepartmentList.length==0){
  store.dispatch("getHrmDepartmentList")
 }

 if(store.getters.getProductMapList.length==0){
  store.dispatch("getProductMapList")
 }

 store.dispatch("getRawMetarialRequisitionList")

 const user = store.getters.getAuthUser

 receive_by.value.value=user.full_name
 receive_by_mobile.value.value=user.mobile
 receive_by_email.value.value=user.email

 requisition_delivery_date.value.value=new Date()

if(requisition_delivery_master_id){
  loadEditData(requisition_delivery_master_id)
}

})

</script>